/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from '@apollo/client';
import { useMemo } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import { TriggerResendSalesOrdersByBillingCycles, TriggerResendSalesOrdersByBillingCyclesVariables } 
  from '@/graphql/contracts/_generated_/triggerResendSalesOrdersByBillingCycles.mutation';
import TriggerResendSalesOrdersByBillingCyclesMutation
  from '@/graphql/contracts/triggerResendSalesOrdersByBillingCycles.mutation.gql';

interface ResendSalesOrderParams {
  salesOrderIds: string[];
  onSuccess?: () => void;
}

export function useResendSalesOrdersByBillingCycles() {
  const [mutate] = useMutation<
  TriggerResendSalesOrdersByBillingCycles,
  TriggerResendSalesOrdersByBillingCyclesVariables
  >(TriggerResendSalesOrdersByBillingCyclesMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const resendSalesOrdersByBillingCycles = ({
    salesOrderIds,
    onSuccess,
  }: ResendSalesOrderParams) => {
    mutate({
      variables: {
        salesOrderIds,
      },
      onCompleted: (response) => {
        if (response?.triggerResendSalesOrdersByBillingCycles?.triggeredCount) {
          onSuccess?.();
        }

        notificationService.open({
          title: 'Resending Failed Sales Orders by Billing Cycles',
          text: 'Sales Orders by Billing Cycles resending triggered successfully',
          type: 'success',
        });
      },
    });
  };

  return useMemo(
    () => ({
      resendSalesOrdersByBillingCycles,
    }),
    [],
  );
}
